import { render, staticRenderFns } from "./RetirementChicksByCorralItem.vue?vue&type=template&id=4b0302f0&scoped=true"
import script from "./RetirementChicksByCorralItem.vue?vue&type=script&lang=js"
export * from "./RetirementChicksByCorralItem.vue?vue&type=script&lang=js"
import style0 from "./RetirementChicksByCorralItem.vue?vue&type=style&index=0&id=4b0302f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0302f0",
  null
  
)

export default component.exports